document.addEventListener("DOMContentLoaded", function () {
  const wishlistKey = "wishlist"; 
  let wishlist = JSON.parse(localStorage.getItem(wishlistKey)) || [];

  function updateWishlistButton(productId) {
    document.querySelectorAll(`.wishlist-button[data-product-id="${productId}"]`).forEach(button => {
      const icon = button.querySelector(".wishlist-icon path");
      if (wishlist.some(item => item.id === productId)) {
        icon.setAttribute("fill", "#f21970");
        icon.setAttribute("stroke", "#f21970");
      } else {
        icon.setAttribute("fill", "none");
        icon.setAttribute("stroke", "#f21970");
      }
    });
  }

  function toggleWishlist(event) {
    event.preventDefault();
    event.stopPropagation();

    const button = event.target.closest(".wishlist-button");
    if (!button) return;

    const productId = button.getAttribute("data-product-id");
    const productTitle = button.getAttribute("data-product-title");
    const productImage = button.getAttribute("data-product-image");
    const productPrice = button.getAttribute("data-product-price");
    const productHandle = button.getAttribute("data-product-handle");
    const variantId = button.getAttribute("data-variant-id");
    const available = button.getAttribute("data-available") === "true";

    if (!variantId || variantId === "undefined" || variantId === "") {
      console.error("❌ Chyba: Chýba variant ID pre produkt:", productTitle);
      return;
    }

    const productData = {
      id: productId,
      variantId: variantId,
      title: productTitle,
      image: productImage,
      price: productPrice,
      handle: productHandle,
      available: available
    };

    if (wishlist.some(item => item.id === productId)) {
      wishlist = wishlist.filter(item => item.id !== productId);
      showNotification("❌ Produkt odstránený z wishlistu");
    } else {
      wishlist.push(productData);
      showNotification(available ? "✅ Produkt pridaný do wishlistu" : "⚠️ Produkt pridaný do wishlistu (vypredaný)");
      animateWishlistButton(button);
    }

    localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
    updateWishlistButton(productId);
    renderWishlist();
  }

  function showNotification(message) {
    const notification = document.createElement("div");
    notification.classList.add("wishlist-notification");
    notification.textContent = message;
    document.body.appendChild(notification);
    setTimeout(() => {
      notification.remove();
    }, 2000);
  }

  function fixWishlistClickability() {
    document.querySelectorAll(".wishlist-button").forEach(button => {
      button.style.pointerEvents = "auto";
    });
  }

  function renderWishlist() {
    const wishlistContainer = document.getElementById("wishlist-items");
    const wishlistCountText = document.getElementById("wishlist-count");
    const wishlistHomeButton = document.getElementById("wishlist-home");

    wishlist = JSON.parse(localStorage.getItem(wishlistKey)) || [];
    wishlistContainer.innerHTML = "";

    if (wishlist.length === 0) {
      wishlistCountText.textContent = "";
      wishlistHomeButton.style.display = "inline-block";
      return;
    } else {
      wishlistCountText.textContent = wishlist.length;
      wishlistHomeButton.style.display = "none";
    }

   wishlist.forEach(item => {
    let productUrl = `/products/${item.handle}`;
    const productElement = document.createElement("div");
    productElement.classList.add("wishlist-item");

    productElement.innerHTML = `
        <button class="remove-wishlist" data-id="${item.id}">✖</button>
        <a href="${productUrl}" class="wishlist-product-link">
            <img src="${item.image}" alt="${item.title}">
            <h3>${item.title}</h3>
        </a>
        <p class="wishlist-price">${item.price}</p>
        ${item.available 
          ? "" /* `<button class="add-to-cart" data-variant-id="${item.variantId}">Pridať do košíka</button>` */ // ⬅️ TLAČIDLO ZAKOMENTOVANÉ
          : `<span class="out-of-stock">⚠️ Vypredané</span>`}
    `;

    wishlistContainer.appendChild(productElement);
});


    document.querySelectorAll(".remove-wishlist").forEach(button => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const productId = this.getAttribute("data-id");

        wishlist = wishlist.filter(item => item.id !== productId);
        localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
        renderWishlist();
      });
    });

    document.querySelectorAll(".add-to-cart").forEach(button => {
      button.addEventListener("click", function (event) {
        event.preventDefault();
        const variantId = button.getAttribute("data-variant-id");
        if (!variantId || variantId === "undefined" || variantId === "") {
          console.error("❌ Chyba: Chýba variant ID pri pridávaní do košíka");
          return;
        }
        addToCart(variantId);
      });
    });

    fixWishlistClickability();
  }

  function addToCart(variantId) {
    fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 }) 
    })
    .then(response => response.json())
    .then(data => {
        console.log('✅ Produkt bol pridaný do košíka:', data);
        updateCartIcon();  // 🔥 Opravená aktualizácia čísla v košíku
        showCartNotification();
    })
    .catch(error => console.error('❌ Chyba pri pridávaní do košíka:', error));
  }

  function showCartNotification() {
    const notification = document.getElementById("cart-notification");
    if (!notification) return;
    notification.classList.add("active");
    setTimeout(() => {
      notification.classList.remove("active");
    }, 3000);
  }

  function updateCartIcon() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        let cartBubble = document.querySelector('.cart-count-bubble');

        if (!cartBubble) {
          console.warn("⚠️ Element .cart-count-bubble neexistuje! Vytváram ho...");
          const cartIcon = document.querySelector('#cart-icon-bubble');
          if (cartIcon) {
            cartBubble = document.createElement('div');
            cartBubble.classList.add('cart-count-bubble');
            cartIcon.appendChild(cartBubble);
          } else {
            console.error("❌ Element #cart-icon-bubble neexistuje!");
            return;
          }
        }

        cartBubble.textContent = cart.item_count > 0 ? cart.item_count : "";
        cartBubble.style.display = cart.item_count > 0 ? 'flex' : 'none';
      })
      .catch(error => console.error("❌ Chyba pri aktualizácii košíka:", error));
  }

  function animateWishlistButton(button) {
    button.classList.remove("wishlist-animate-add");
    void button.offsetWidth;
    button.classList.add("wishlist-animate-add");
    setTimeout(() => {
      button.classList.remove("wishlist-animate-add");
    }, 300);
  }

  document.addEventListener("click", function (event) {
    if (event.target.closest(".wishlist-button")) {
      toggleWishlist(event);
    }
  });

  wishlist.forEach(item => {
    updateWishlistButton(item.id);
  });

/** ✅ Kontrola skladovej dostupnosti pri načítaní wishlistu **/
function checkStockUpdates() {
    if (wishlist.length === 0) return;

    fetch('/products.json')
      .then(response => response.json())
      .then(data => {
        wishlist = wishlist.map(item => {
          const product = data.products.find(p => p.variants.some(v => v.id == item.variantId));
          if (product) {
            const variant = product.variants.find(v => v.id == item.variantId);
            item.available = variant ? variant.available : false; // ✅ Aktualizácia dostupnosti
          }
          return item;
        });

        localStorage.setItem(wishlistKey, JSON.stringify(wishlist));
        renderWishlist(); // ✅ Opätovné vykreslenie wishlistu s aktualizovanými zásobami
      })
      .catch(error => console.error("❌ Chyba pri aktualizácii skladovej dostupnosti:", error));
}

/** ✅ Spustenie kontroly skladových zásob **/
checkStockUpdates(); // Skontroluje dostupnosť pri načítaní stránky




  renderWishlist();
});
